export default {
  control: {
    backgroundColor: "#fff",
    fontSize: 14,
    fontWeight: "normal",
  },

  "&multiLine": {
    display: "inline-block",
    width: '100%',
    paddingRight: '50px',
    control: {
      // fontFamily: "monospace",
      minHeight: 50,
    },
    highlighter: {
      // padding: 9,
      padding: '12px 0 0 14px',
      // border: "1px solid transparent",
      // outline: 'none'
    },
    input: {
      padding: 9,
      border: "1px solid black",
      outline: 'none',
      margin: '0 !important',
    },
    textarea: {
      appearance: 'none',
      outline: 'none',
      border: '1px solid #C7CAD1',
      borderRadius: '8px',
      height: '48px',
      padding: '12px 50px 0 14px',
    }
  },

  "&singleLine": {
    display: "inline-block",
    width: '100%',
    paddingRight: '100px',
    highlighter: {
      padding: '13px 110px 13px 14px',
      backgroundColor: 'transparent',
    }
  },

  suggestions: {
    list: {
      backgroundColor: "white",
      borderRadius: '8px',
      border: "1px solid #E3E5E8",
      padding:'6px 8px',
      fontSize: 14,
      width:'303px',
      maxHeight: '235px',
      boxShadow: "0px 8px 15px 2px rgba(46, 49, 56, 0.1), 0px 0px 2px rgba(46, 49, 56, 0.15)",
      overflowY: "auto",
    },
    item: {
      padding: '2px 50px 2px 14px',
      // borderBottom: "1px solid rgba(0,0,0,0.15)",
      "&focused": {
        backgroundColor: "#EEEEEE",
      },
    },
  },
};
